import { createElement } from 'react';

const identity = Component => Component;

export const branch = (condition, left, right = identity) => BaseComponent => {
	let leftComponent;
	let rightComponent;

	const Branch = props => {
		if (condition(props)) {
			leftComponent = leftComponent || left(BaseComponent);
			return createElement(leftComponent, props);
		}
		rightComponent = rightComponent || right(BaseComponent);
		return createElement(rightComponent, props);
	};
	return Branch;
};
